import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles(() =>
  createStyles({
    viewContainer: {
      flexGrow: 1,
    },
  })
)
